import loadable from '@loadable/component';

const BlogEditPage = loadable(() => import('./BlogEditPage'));

export { BlogEditPage };
